import React, {useState} from "react";
import "./MCAProgram.css"; 
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import CTAButtons from "../components/sticky-button";
import PageHeader from "../about/PageHeader";
import BrochureForm from "../components/EnquiryForm"; 
import ContactAdmissionsStrip from "../components/ContactAdmissionsStrip"; 

const SupervisorIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-feature-svg">
    <circle cx="9" cy="8" r="3" />
    <path d="M4.5 18a4.5 4.5 0 0 1 9 0" />
    <circle cx="17.5" cy="9" r="2.5" />
    <path d="M15.5 18a3.5 3.5 0 0 1 5 0" />
  </svg>
);

const BiotechIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-feature-svg">
    <path d="M9 3.5c2.5 2 4 4.6 4 7.4A6.5 6.5 0 1 1 6.5 4.4" />
    <path d="M15 20.5c-2.5-2-4-4.6-4-7.4A6.5 6.5 0 1 1 17.5 19.6" />
    <path d="M8 8h8" />
    <path d="M8 12h8" />
    <path d="M8 16h8" />
  </svg>
);

const HubIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-feature-svg">
    <circle cx="12" cy="5" r="2.3" />
    <circle cx="5" cy="17" r="2.3" />
    <circle cx="19" cy="17" r="2.3" />
    <path d="M12 7.3v4.2" />
    <path d="M12 11.5 6.8 14.6" />
    <path d="M12 11.5l5.2 3.1" />
  </svg>
);

const VerifiedIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-feature-svg">
    <path d="M12 3.5 18.5 6v5.5c0 4.2-2.5 7.2-6.5 9-4-1.8-6.5-4.8-6.5-9V6L12 3.5Z" />
    <path d="m9.2 12.3 1.9 1.9 3.9-4.2" />
  </svg>
);

const DescriptionIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-feature-svg">
    <path d="M7 3.5h7l3 3V20a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 6 20V5A1.5 1.5 0 0 1 7.5 3.5Z" />
    <path d="M14 3.5V7h3" />
    <path d="M9 11h6" />
    <path d="M9 15h6" />
  </svg>
);

const PsychologyIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-feature-svg">
    <path d="M12 21c4.4 0 8-3.4 8-7.7 0-3.8-2.8-6.9-6.4-7.6A5.5 5.5 0 0 0 4 9.5c0 2.1 1.2 4 3 5" />
    <path d="M10.5 10.5c0-1.4 1-2.5 2.4-2.5s2.6 1.1 2.6 2.5c0 1-.4 1.6-1.3 2.3-.7.5-1.2 1-1.2 2" />
    <circle cx="13" cy="17.2" r=".8" fill="#5865f2" stroke="none" />
  </svg>
);

const UsersIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-feature-svg">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm14 10v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const BuildingIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-stat-svg">
    <path d="M3 21h18M5 21V7l7-3 7 3v14M8 10h2m-2 4h2m-2 4h2m4-8h2m-4 4h2m-4 4h2" />
  </svg>
);

const GraduationIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-stat-svg">
    <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
    <path d="M6 12v5c0 2 2 3 6 3s6-1 6-3v-5" />
  </svg>
);

const GroupIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-feature-svg">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm14 10v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

export default function PhdProgram() {
  const [showForm, setShowForm] = useState(false);  

  // --- FIXED ASSET HELPER: Added || '' to prevent undefined paths ---
  const asset = (path) => `${process.env.PUBLIC_URL || ''}${path.startsWith('/') ? path : `/${path}`}`;

  const phdFeatures = [
    {
      title: "Expert Research Supervision",
      desc: "Guidance provided by University-approved research supervisors with extensive academic, research, and industry experience.",
      icon: <SupervisorIcon />
    },
    {
      title: "Focused Research Domains",
      desc: "Opportunities to pursue advanced research in Artificial Intelligence, Machine Learning, Data Science, Cybersecurity, Software Engineering, Educational Technology, and other interdisciplinary areas.",
      icon: <BiotechIcon />
    },
    {
      title: "Research Ecosystem",
      desc: "Access to state-of-the-art computing infrastructure, digital libraries, and research databases, supporting high-quality research and experimentation.",
      icon: <HubIcon />
    },
    {
      title: "Collaborative & Interdisciplinary Research",
      desc: "Encouragement for collaboration across disciplines and partnerships with industry, academia, and research institutions for impactful outcomes.",
      icon: <GroupIcon />
    },
    {
      title: "Capacity Building & Knowledge Sharing",
      desc: "Regular research colloquia, doctoral workshops, FDPs, and paper presentation sessions to enhance scholarly competence.",
      icon: <UsersIcon />
    },
    {
      title: "Ethics & Quality Assurance",
      desc: "Adherence to the University of Mumbai’s Ph.D. regulations, plagiarism policies, and academic integrity standards.",
      icon: <VerifiedIcon />
    },
    {
      title: "Publication & Dissemination Support",
      desc: "Mentorship for publishing in peer-reviewed, indexed journals and presenting at reputed national and international conferences.",
      icon: <DescriptionIcon />
    },
    {
      title: "Research Culture of Excellence",
      desc: "A vibrant and intellectually stimulating environment promoting innovation, critical inquiry, and evidence-based problem-solving.",
      icon: <PsychologyIcon />
    }
  ];

  return (
    <>
      <Navbar />
      <CTAButtons />
      <PageHeader
        title="Ph.D. (Computer Applications)"
        crumbs={[{ label: 'Home', href: '/' }, { label: 'Ph.D. Admission' }]}
      />
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <div className="mca-page-bg phd-program-page">
        <div className="mca-ig-wrapper">
          <div className="mca-ig-container">
            {/* Section 1: Overview */}
            <div className="mca-ig-overview-card">
              <div className="mca-ig-image-box">
                {/* --- FIXED PATH: Folder is "Program" and file is "Phd.webp" based on the screenshot --- */}
                <img
                  src={asset('/Program/Phd.webp')}
                  alt="Ph.D. Research"
                  className="mca-ig-hero-img"
                />
                <div className="mca-ig-image-overlay">
                  <h3>Ph.D. Research Centre</h3>
                  <p>Affiliated with the University of Mumbai under the Faculty of Science and Technology.</p>
                </div>
              </div>

              <div className="mca-ig-text-content">
                <p className="mca-ig-para">
                  Thakur Institute of Management Studies, Career Development & Research (TIMSCDR) is an approved Ph.D. Research Centre affiliated with the University of Mumbai. The program is conducted under the Faculty of Science and Technology and follows all regulations, directions, and quality standards prescribed by the University of Mumbai.
                </p>
                <p className="mca-ig-para">
                  Research scholars are guided by University-approved research supervisors, ensuring academic rigor and adherence to ethical research practices. The University of Mumbai’s policies and guidelines are strictly followed in the conduct of research, evaluation, and the award of the Ph.D. degree.
                </p>
              </div>
            </div>

            {/* Section 2: Key Features Grid */}
            <div className="mca-ig-grid">
              {phdFeatures.map((feature, index) => (
                <div key={index} className="mca-ig-card">
                  <div className="mca-ig-icon-wrapper">
                    {feature.icon}
                  </div>
                  <div className="mca-ig-card-info">
                    <h4>{feature.title}</h4>
                    <p>{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Section 3: Full Width Stats Bar */}
          <div className="mca-ig-stats-row">
            <div className="mca-ig-stat-item">
              <div className="mca-ig-stat-icon-wrapper">
                <BuildingIcon />
              </div>
              <div className="mca-ig-stat-text-box">
                <span className="mca-ig-stat-value">2024–25</span>
                <span className="mca-ig-stat-label">Establishment</span>
              </div>
            </div>
            <div className="mca-ig-stat-item">
              <div className="mca-ig-stat-icon-wrapper">
                <UsersIcon />
              </div>
              <div className="mca-ig-stat-text-box">
                <span className="mca-ig-stat-value">10</span>
                <span className="mca-ig-stat-label">Intake Capacity</span>
              </div>
            </div>
            <div className="mca-ig-stat-item">
              <div className="mca-ig-stat-icon-wrapper">
                <GraduationIcon />
              </div>
              <div className="mca-ig-stat-text-box">
                <span className="mca-ig-stat-value">Computer Applications</span>
                <span className="mca-ig-stat-label">Faculty</span>
              </div>
            </div>
          </div>
        </div>
              <ContactAdmissionsStrip onAppointmentClick={() => setShowForm(true)} />
        
      </div>
      <Footer />
    </>
  );
}